import { Component, Input } from '@angular/core'
import { Portfolio } from 'src/app/features/portfolio/portfolio.model'

@Component({
  selector: 'app-style-boxing',
  templateUrl: './style-boxing.component.html',
  styleUrls: ['./style-boxing.component.scss'],
})
export class StyleBoxingComponent {
  @Input() portfolioModel: Portfolio

  styleBoxEquity: string

  // eslint-disable-next-line complexity
  setInvestmentStyle() {
    if (!this.portfolioModel?.profileData?.equityInvestmentStyleId) {
      this.styleBoxEquity = ''
      return
    }

    let HorizantalValue = 'Investment Style '
    let VerticalValue = 'Market Captialization '
    switch (this.portfolioModel.profileData.equityInvestmentStyleId) {
      case '1':
        VerticalValue = VerticalValue.concat('Large')
        HorizantalValue = HorizantalValue.concat('Value')
        break
      case '2':
        VerticalValue = VerticalValue.concat('Large')
        HorizantalValue = HorizantalValue.concat('Blend')
        break
      case '3':
        VerticalValue = VerticalValue.concat('Large')
        HorizantalValue = HorizantalValue.concat('Growth')
        break
      case '4':
        VerticalValue = VerticalValue.concat('Mid')
        HorizantalValue = HorizantalValue.concat('Value')
        break
      case '5':
        VerticalValue = VerticalValue.concat('Mid')
        HorizantalValue = HorizantalValue.concat('Blend')
        break
      case '6':
        VerticalValue = VerticalValue.concat('Mid')
        HorizantalValue = HorizantalValue.concat('Growth')
        break
      case '7':
        VerticalValue = VerticalValue.concat('Small')
        HorizantalValue = HorizantalValue.concat('Value')
        break
      case '8':
        VerticalValue = VerticalValue.concat('Small')
        HorizantalValue = HorizantalValue.concat('Blend')
        break
      case '9':
        VerticalValue = VerticalValue.concat('Small')
        HorizantalValue = HorizantalValue.concat('Growth')
        break
    }
    this.styleBoxEquity = VerticalValue + ' ' + HorizantalValue
  }

  ngOnInit() {
    this.setInvestmentStyle()
  }
}
